module.exports = __webpack_public_path__ + "static/img/big_vote_B.e533cf7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/big_vote_B.png
// module id = skBq
// module chunks = 1